import React from 'react';
import { Alert, Button, Box } from '@mui/material';
import { LockOpen as LockOpenIcon } from '@mui/icons-material';

interface SurveyLockedBannerProps {
  onSetToDraft: () => void;
  isLoading?: boolean;
}

export const SurveyLockedBanner: React.FC<SurveyLockedBannerProps> = ({
  onSetToDraft,
  isLoading = false,
}) => {
  return (
    <Alert
      severity="info"
      sx={{
        display: 'flex',
        alignItems: 'center',
        '& .MuiAlert-message': {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          py: 0,
        },
      }}
    >
      <Box sx={{ flex: 1 }}>
        This survey is active and can be shared with students. To edit questions, set it to draft
        mode first.
      </Box>
      <Box sx={{ ml: 'auto' }}>
        <Button
          variant="contained"
          startIcon={<LockOpenIcon />}
          onClick={onSetToDraft}
          disabled={isLoading}
          size="small"
        >
          Set to Draft
        </Button>
      </Box>
    </Alert>
  );
};
